<template>
	<section class="message">
		<div class="nurse_func">
			<p>Данный функционал будет добавлен в проект в ближайшее время.</p>
			<p>Следите за обновлениями проекта.</p>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'Message'
	}
</script>



// WEBPACK FOOTER //
// Message.vue?dea5b240